import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import Testimonial from 'components/Testimonial';

import useSchoolContext from 'hooks/useSchoolContext';

export function Testimonials() {
  const theme = useTheme();
  const schoolContext = useSchoolContext();

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          sx={{
            fontWeight: 700,
            marginTop: theme.spacing(1),
          }}
        >
          Testimonials
        </Typography>
        <Typography variant="h6" color={'text.secondary'} align="center">
          Feedback from parents and students who&apos;ve completed our program.
          <br />
          Here&apos;s what they have to say.
        </Typography>
      </Box>
      <Grid container spacing={2}>
        {schoolContext?.testimonials?.map(({ id, author, authorSubtitle, content, rating }) => (
          <Grid key={id} size={{ xs: 12, md: 4 }}>
            <Testimonial author={author} authorSubtitle={authorSubtitle} content={content} rating={rating} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default Testimonials;
